import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../api/api';

export const getTenantsCreditNotPaginated = createAsyncThunk('Tenant/getTenantCreditBalance', async ({}) => {
    try {
        let url = 'tenants/getTenantCreditBalance';
        const { data } = await api.get(url);
        return data;
    } catch (error) {}
});
